// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import {TimeUtil} from './utils/TimeUtil'
import VueCookies from 'vue-cookies'
import store from './store'
import * as echarts from 'echarts'
import goodsConfig from './global/goodsConfig'
import userConfig from './global/userConfig'
import {MessageUtil} from './utils/MessageUtil'
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.prototype.TimeUtil = TimeUtil
Vue.prototype.goodsConfig = goodsConfig
Vue.prototype.userConfig = userConfig
Vue.prototype.MessageUtil = MessageUtil

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
Vue.use(VueCookies).use({ vue })

export default vue



// WEBPACK FOOTER //
// ./src/main.js